import axiosInstance from "./axiosInstance";

let cachedKey = null;

const base64ToArrayBuffer = (base64) => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
};

function arrayBufferToBase64(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
}

export const rsaService = {
  getPublicKey: async () => {

    // ✅ Always return same structure
    if (cachedKey) {
      return cachedKey;
    }

    console.log("Calling /public-key API");

    const res = await axiosInstance.get("/public-key", {
      headers: { authType: "PreLogin" }
    });

    const { publicKey, id } = res.data;

    const cryptoKey = await window.crypto.subtle.importKey(
      "spki",
      base64ToArrayBuffer(publicKey),
      {
        name: "RSA-OAEP",
        hash: "SHA-256"
      },
      false,
      ["encrypt"]
    );

    cachedKey = { key: cryptoKey, id };

    return cachedKey;
  },

  encrypt: async (text) => {
    const { key, id } = await rsaService.getPublicKey();

    if (!(key instanceof CryptoKey)) {
      throw new Error("Key is not CryptoKey");
    }

    const encoded = new TextEncoder().encode(text);

    const encrypted = await window.crypto.subtle.encrypt(
      { name: "RSA-OAEP" },
      key,
      encoded
    );

    return {
      cipherText: arrayBufferToBase64(encrypted),
      keyId: id
    };
  }
};